import React from 'react';
import Wrapper from './styles';
import { BsStarFill, BsStarHalf, BsStar } from 'react-icons/bs';

const Stars = ({ stars, reviews }) => {
  const tempStars = Array.from({ length: 5 }, (_, index) => {
    const number = index + 0.5;
    return (
      <span key={index}>
        {stars >= index + 1 ? (
          <BsStarFill className='starClass' fill='#F4B41A' />
        ) : stars >= number ? (
          <BsStarHalf className='starClass' fill='#F4B41A' />
        ) : (
          <BsStar className='starClass' fill='#F4B41A' />
        )}
      </span>
    );
  });

  return (
    <Wrapper>
      <div className='stars'>{tempStars}</div>
      <p className='reviews'>({reviews})</p>
    </Wrapper>
  );
};

export default Stars;
